// extracted by mini-css-extract-plugin
export default {"input":"input","ant-input-group-addon":"ant-input-group-addon","antInputGroupAddon":"ant-input-group-addon"};